import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { handleFormValueChange } from 'actions/signupForm/addOrEdit'
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  Select,
  MenuItem,
  withStyles,
  FormHelperText,
} from '@material-ui/core'
import styles from './styles'

import ColorPicker from './ColorPicker'

export default connect(
  (state, { property }) => ({
    value: state.signupForm.addOrEdit.values[property].value,
    error: state.signupForm.addOrEdit.values[property].error
      ? state.signupForm.addOrEdit.values[property].error
      : null,
  }),
  dispatch => bindActionCreators({ handleFormValueChange }, dispatch),
)(
  withStyles(styles)(
    class TextField extends Component {
      componentDidMount() {
        this.forceUpdate()
      }

      render() {
        const {
          value,
          handleFormValueChange,
          property,
          label,
          disabled,
          placeholder,
          select,
          items,
          color,
          error,
          classes,
          selectTemplate,
        } = this.props

        return (
					<FormControl
						fullWidth
						variant="outlined"
						disabled={Boolean(disabled)}
						error={Boolean(error)}
					>
						<InputLabel
							ref={(ref) => {
								this.labelRef = ReactDOM.findDOMNode(ref)
							}}
							htmlFor={`formTextField${label}`}
							shrink
							style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
						>
							{label}
						</InputLabel>
						{select ? (
							<Select
								value={value}
								onChange={(e) =>
									handleFormValueChange(property, e.target.value)
								}
								input={
									<OutlinedInput
										labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
										id={`formTextField${label}`}
										classes={{
											notchedOutline: classes.notchedOutline,
										}}
									/>
								}
							>
								{selectTemplate
									? items.map((item) => selectTemplate(item))
									: items.map((item) => (
											<MenuItem
												key={`formsFormValue${item.value}`}
												value={item.value}
											>
												{item.label}
											</MenuItem>
									  ))}
							</Select>
						) : (
							<OutlinedInput
								id={`formTextField${label}`}
								labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
								value={value}
								onChange={(e) =>
									handleFormValueChange(property, e.target.value)
								}
								placeholder={placeholder}
								notched
								classes={{
									notchedOutline: classes.notchedOutline,
								}}
								endAdornment={
									color ? (
										<ColorPicker
											value={value}
											handleFormValueChange={(value) =>
												handleFormValueChange(property, value)
											}
										/>
									) : null
								}
							/>
						)}
						<FormHelperText error={Boolean(error)}>{error}</FormHelperText>
					</FormControl>
				)
      }
    },
  ),
)
